
  (function () {
    // When a link to intake is clicked, append the real Everflow transaction id
    // AND the offer/affiliate so the intake/checkout app reuses THIS exact brand
    // click (the one that carries sub5) instead of minting a new, sub5-less,
    // offer-less one. The Next app re-fires EF.click({transaction_id: ef_tid,
    // offer_id, affiliate_id}); without oid/affid that re-fire can mint a fresh
    // offer-less click that detaches the conversion (and its sub5) entirely.
    var pageParams = new URLSearchParams(window.location.search);
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="intake.wellmedr.com"]');
      if (!a) return;
      if (!window.EF || typeof window.EF.getTransactionId !== 'function') return;

      // offer id comes from the affiliate link already in this page's URL (?oid=...)
      var oid = pageParams.get('oid');
      var tid = oid ? window.EF.getTransactionId(parseInt(oid, 10)) : '';
      if (!tid) return; // nothing yet — let the normal link work (cookie still credits the conversion)

      try {
        var url = new URL(a.href);
        if (!url.searchParams.get('ef_tid') && !url.searchParams.get('_ef_transaction_id')) {
          url.searchParams.set('ef_tid', tid);
          if (oid && !url.searchParams.get('oid')) url.searchParams.set('oid', oid);
          var affid = pageParams.get('affid');
          if (affid && !url.searchParams.get('affid')) url.searchParams.set('affid', affid);
          a.href = url.toString();
        }
      } catch (err) {}
    }, true); // capture phase → runs before navigation
  })();
